<script>
  import { closeAllModals, closeModal } from "svelte-modals/legacy"
  import Card from "@objects/Card.svelte"
  import Dialog from "@objects/Dialog.svelte"
  import DialogHeader from "@components/dialogs/DialogHeader.svelte"
  import Container from "@objects/Container.svelte"
  import Button from "@components/Button.svelte"
  import Icon from "@components/Icon.svelte"
  import { merchant } from "@store/auth.js"
  import SubmitButton from "@components/SubmitButton.svelte"
  import notifications from "@store/notifications.js"
  import { useForm } from "@inertiajs/svelte"
  import asset from "@helpers/asset.js"
  import FormField from "@components/FormField.svelte"
  import Textarea from "@components/Textarea.svelte"

  export let isOpen
  export let product

  let isSubmitting = false

  let featuredImageUrl = asset((product.images.find((image) => image.is_featured) || product.images[0])?.url, {
    w: 100,
  })

  const form = useForm({
    message: "",
  })

  const submit = () => {
    isSubmitting = true

    setTimeout(() => {
      closeModal()

      notifications.success({
        message: `Your message has been sent! A representative from ${product.vendor.name} will contact you soon with more information`,
      })
    }, 250)
  }
</script>

{#if isOpen}
  <Dialog on:close={closeAllModals}>
    <Container padding="none" size="small" class="grow">
      <Card type="canvas" class="pb-16 sm:pb-10 md:pb-0" size="none">
        <div class="px-4 pt-4 pb-4 sm:px-6 sm:py-6 md:px-10 md:py-8 lg:px-12 lg:py-10 bg-beige-50">
          <DialogHeader title="Contact {product.vendor.name} Rep" />
        </div>

        <form
          on:submit|preventDefault={submit}
          class="text-left flex flex-col gap-4 px-4 pt-4 pb-4 sm:px-6 sm:py-6 md:px-10 md:py-8 lg:px-12 lg:py-10"
        >
          <div class="flex gap-4 items-center">
            <img src={featuredImageUrl} alt={product.name} class="w-[50px] aspect-square" />

            <div>
              <h4 class="text-xl">{product.name}</h4>
              <h5>{product.sku}</h5>
            </div>
          </div>

          <FormField label="Message" name="message" error={$form.errors.description} class="[ relative mt-4 ]">
            <Textarea
              id="message"
              bind:value={$form.message}
              error={$form.errors.message}
              class="resize-y min-h-[100px]"
              placeholder="Add your message/questions for the rep here…"
            />
          </FormField>

          <div class="flex items-center justify-end">
            <SubmitButton processing={isSubmitting} disabled={!$form.message} type="accent">Send message</SubmitButton>
          </div>
        </form>
      </Card>
    </Container>
  </Dialog>
{/if}
